export default __webpack_public_path__ + "static/media/questions-xs-2x.1a6f6156.webp";